<template>
  <b-modal
    :dialog-class="'md_modal_dialog_full21 site-detail-width ' + detailPopupAlign"
    :body-class="showSetSaleCompletePopup || showSiteInquiryPopup || showDetailNotifyPopup ? 'md_modal_body_scroll_none p-0':'md_modal_body_scroll p-0'"
    :modal-class="page == 'Map' ? 'md_modal_site_detail' : 'md_modal_full'"
    content-class="md_modal_content_full"
    :visible="visible"
    hide-footer
    hide-header
    hide-backdrop
    no-close-on-backdrop
    @show="onShowSiteDetail"
    @hide="onCancel"
  >
    <div :class="page == 'Map' ? 'inquiry_btn1' : 'inquiry_btn2'">
      <b-button
        pill
        class="quick_btn align-horizontal center p-0"
        style="background-color: transparent; width: 60px; height: 60px;"
        @click="onSearch()"
      >
        <b-img :src="require('../../../../assets/image/ic_qb_search@2x.png')"/>
      </b-button>
    </div>
    <div class="container" style="padding:0;">
      <MdHeaderBar
        :is-custom-back="true"
        @back="onCancel"
        :hide_close="true"
        :hide_like="false"
        :hide_share="false"
        :is_like="info.f_like == 'Y'"
        :header_class="'site-detail-width header ' + detailPopupAlign"
        @onLike="onLike"
        @onShare="onShare"
        :title="{
          isSingle: false,
          primary: info.f_name,
          address: u.getAddress(info, true),
          secondary: isAdmin ? '' + info.f_idx : '',
        }"
      />
      <div class="container"
           :style="page == 'Map' ? 'padding-top: 0px' : 'padding-top: 90px'">
        <!--      renderBasicInfo Start-->
        <div class="align-vertical">
          <div v-if="info.f_site_type != 'U'">
            <div
              class="align-horizontal space_between"
              style="margin: 15px 0px 0px 5px;"
            >
              <span class="caption">{{ $t("site_detail.my_field_memo") }}</span>
              <div class="align-vertical">
              <span class="sale_date">
                {{ ut.format($t("site_detail.update_date"), info.f_update_time ? info.f_update_time.substr(0, 10).replace("-", "-"): "") }}</span>
                <span class="sale_date">{{
                    info.f_site_type == "O"
                      ? $t("map.open_date")
                      : $t("map.open_date2")
                  }}
              {{
                    info.f_open_date ? info.f_open_date.replace("-", "-") : ""
                  }}</span>
              </div>
            </div>
            <div style="position: relative">
              <b-form-textarea
                v-model="memo"
                rows="5"
                class="textarea_wrap textarea mt-1"
                :placeholder="$t('site_detail.my_memo_placeholder')"
                style="height: 85px; margin: 0; width: calc(100% - 100px)"
              />
              <b-button
                class="btn btn_text btn_memo"
                variant="primary"
                @click="onSaveMyMemo"
                style="position: absolute; right: 50px; top: 10px"
              >저장</b-button>
              <b-button
                class="btn btn_text btn_memo"
                variant="primary"
                @click="onShowMyMemoImage"
                style="position: absolute; right: 0px; top: 10px"
              >보기</b-button>
              <b-button
                class="btn btn_text btn_memo dark_blue"
                variant="primary"
                @click="onAttachMyMemoImage"
                style="position: absolute; right: 50px; top: 44px"
              >첨부</b-button>
              <input type="file" accept="image/*" @change="onImageChange" style="display: none" ref="img-file">
              <b-button
                class="btn btn_text btn_memo del_btn_color"
                variant="primary"
                @click="onRemoveMyMemoImage"
                style="position: absolute; right: 0px; top: 44px"
              >삭제</b-button>
            </div>
          </div>
          <div class="align-vertical basic_info" style="margin-left: 0;">
            <div class="align-horizontal v_center contact">
              <span class="basic_info_label text1">{{
                  $t("site_detail.site_type")
                }}</span>
              <span class="flex_1 text">{{ maemul_type.join(", ") }}</span>
              <b-button
                class="btn btn_text"
                variant="primary"
                @click="onNavi"
              >{{ $t("interest.navi_connect") }}</b-button
              >
            </div>
            <div class="align-horizontal v_center contact">
              <span class="basic_info_label text1">{{
                  $t("site_detail.building_info")
                }}</span>
              <span class="flex_1 text">{{
                  ut.format(
                    $t("site_detail.build_info"),
                    info.f_dong_count ? info.f_dong_count : 0,
                    info.f_house_count ? info.f_house_count : 0
                  )
                }}</span>
              <b-button
                class="btn btn_text"
                variant="primary"
                @click="copyAddress"
              >{{ $t("interest.copy_address") }}</b-button
              >
            </div>
            <div class="align-horizontal v_center contact">
              <span class="basic_info_label text1">{{
                  $t("site_detail.parking_info")
                }}</span>
              <span class="flex_1 text">{{ parking_info.join(", ") }}</span>
              <div class="btn" style="opacity: 0" />
            </div>
            <div
              class="align-horizontal v_center contact"
              v-for="(contact, idx) in contactList"
              :key="`contact-${idx}`"
            >
              <span class="basic_info_label text1" style="text-align: left">{{
                  contact.f_name
                }}</span>
              <span class="flex_1 text">{{ contact.f_phone }}</span>
              <b-button
                class="btn btn_text"
                variant="primary"
                @click="onPhone(contact.f_phone, contact.f_name)"
              >{{ $t("site_detail.call_phone") }}</b-button
              >
            </div>
          </div>
        </div>
        <!--      renderBasicInfo End-->
        <!--      renderHouseHold Start-->
        <div
          class="align-vertical"
          v-if="info.f_site_type == 'O'"
        >
          <div
            class="v_center"
            style="margin-top: 0; background-color: #f4f5f6; height: 10px"
          />
          <div
            class="align-horizontal v_center"
            style="margin-top: 25px; align-items: center"
          >
            <span class="caption">{{ $t("site_detail.household_info") }}</span>
            <!--
            <span class="update_time">{{
              ut.format(
                $t("site_detail.update_date"),
                info.f_update_time
                  ? info.f_update_time.substr(0, 10).replaceAll("-", "-")
                  : ""
              )
            }}</span>-->

            <div class="align-horizontal" style="flex: 1; justify-content: flex-end">
              <b-button
                v-if="self.myinfo.uid == info.f_user_idx || isAdmin || isGroupMember"
                class="btn btn_text dark_blue"
                style="margin-left: 10px;"
                variant="primary"
                @click="onModify()"
              >{{ $t("common.modify") }}</b-button>
              <b-button
                v-if="self.myinfo.uid == info.f_user_idx || isAdmin || isGroupMember"
                variant="primary"
                class="btn btn_text dark_blue"
                style="margin-left: 10px;"
                @click="onSiteCompletePopup"
              >{{ $t("site_report.site_completion1") }}</b-button
              >
              <b-button
                @click="onCompleteReport"
                variant="primary"
                class="btn btn_text dark_blue"
                style="margin-left: 10px;"
              >
                {{ $t("map.site_report") }}
              </b-button>
            </div>
          </div>
          <div
            class="align-vertical"
            v-for="(
              {
                dong_name,
                floorList,
                hoList,
                saleShow,
                investShow,
                charterShow,
                monthlyShow,
              },
              dong_idx
            ) in forRenderHousehold"
            :key="`dong-group-${dong_idx}`"
            style="margin-top: 10px"
          >
            <span class="caption1"
            >{{ dong_name }}{{ $t("register.dong") }}</span
            >
            <div class="align-vertical" style="margin-top: 10px">
              <div
                class="align-horizontal"
                v-for="(floor, idx) in Object.keys(floorList).sort((a, b) => {
                  return a - b;
                })"
                :key="`grid-floor-${idx}`"
                style="margin-bottom: 4px"
              >
                <b-button
                  v-for="(room, index) in floorList[floor].sort((a, b) => {
                    return a.f_ho - b.f_ho;
                  })"
                  :key="`grid-room-${idx}-${index}`"
                  class="grid_item align-vertical"
                  :class="{ grid_item_complete: room.f_complete == 'Y' }"
                  :style="{ marginLeft: index > 0 ? '4px' : '0' }"
                  style="position: relative; height: 140px; justify-content: flex-start"
                  @click="
                    () => {
                      u.setState(self, { showPopup: true, roomInfo: room });
                    }
                  "
                >
                  <div class="trans_wrapper align-horizontal">
                    <div class="trans_tag"
                         :class="{'trans_trading_active': room.f_trans_type.split(',').includes('0')}">
                      {{floorList[floor].length <= $c.MAX_HO_CNT_PER_LINE_NORMAL_DISPLAY ? $t('trans_type_short')[0] : ''}}
                    </div>
                    <div class="trans_tag"
                         :class="{'trans_charter_active': room.f_trans_type.split(',').includes('1')}">
                      {{floorList[floor].length <= $c.MAX_HO_CNT_PER_LINE_NORMAL_DISPLAY ? $t('trans_type_short')[1] : ''}}
                    </div>
                    <div class="trans_tag"
                         :class="{'trans_month_active': room.f_trans_type.split(',').includes('3')}">
                      {{floorList[floor].length <= $c.MAX_HO_CNT_PER_LINE_NORMAL_DISPLAY ? $t('trans_type_short')[3] : ''}}
                    </div>
                    <div class="trans_tag"
                         :class="{'trans_invest_active': room.f_trans_type.split(',').includes('2')}">
                      {{floorList[floor].length <= $c.MAX_HO_CNT_PER_LINE_NORMAL_DISPLAY ? $t('trans_type_short')[2] : ''}}
                    </div>
                  </div>
                  <div class="align-horizontal v_center h_center width_100 flex_1">
                    <b-img
                      :src="require('../../../../assets/image/ic_photo.png')"
                      v-if="
                        room.f_image_urls.split(',').filter((it) => {
                          return it != '';
                        }).length > 0
                      "
                      style="
                        margin-right: 5px;
                        width: 20px;
                        height: 17px;
                        margin-bottom: 2px;
                      "
                    />
                    <span
                      class="grid_text"
                      :style="{
                        color: room.f_complete == 'Y' ? 'white' : 'black',
                      }"
                    >{{ room.f_ho }}</span
                    >
                  </div>
                  <div class="room_toilet_wrapper align-horizontal">
                    {{
                      floorList[floor].length <= $c.MAX_HO_CNT_PER_LINE_NORMAL_DISPLAY ?
                        ut.format($t('site_detail.room_toilet_num'), renderRoomNum(room.f_room), room.f_toilet) :
                        ut.format($t('site_detail.room_toilet_num_short'), renderRoomNum(room.f_room), room.f_toilet)
                    }}
                  </div>
                  <div class="dup_teras_wrapper align-horizontal">
                    <div class="trans_tag" :class="{'dup_teras_active': room.f_duplex == 'Y'}">
                      {{floorList[floor].length < $c.MAX_HO_CNT_PER_LINE_NORMAL_DISPLAY - 1  ?
                      $t('room_info_popup.duplex') : $t('room_info_popup.duplex_short')}}
                    </div>
                    <div class="trans_tag" :class="{'dup_teras_active': room.f_teras == 'Y'}">
                      {{floorList[floor].length < $c.MAX_HO_CNT_PER_LINE_NORMAL_DISPLAY - 1  ?
                      $t('site_detail.teras') : $t('site_detail.teras_short')}}
                    </div>
                  </div>
                  <div class="complete_mask" v-if="room.f_complete == 'Y'">
                    {{$t("site_detail.done")}}
                  </div>
                </b-button>
              </div>
            </div>

            <div
              class="align-vertical table"
              style="margin-top: 5px; margin-bottom: 10px"
            >
              <div class="align-horizontal thead">
                <div class="th" style="width: 50px">
                  <span class="cell_text_bold">{{ $t("register.ho") }}</span>
                </div>
                <div class="th" style="flex: 0.5">
                  <span class="cell_text_bold">{{ $t("register.room") }}</span>
                </div>
                <div class="th" style="flex: 0.5">
                  <span class="cell_text_bold">{{
                      $t("site_detail.toilet1")
                    }}</span>
                </div>
                <div class="th trans_trading_active" v-if="saleShow" style="flex: 1">
                  <span class="cell_text_bold" style="color: white">{{
                      $t("register.parcel_out")
                    }}</span>
                </div>
                <div class="th trans_trading_active"
                     v-if="saleShow" style="flex: 1">
                  <span class="cell_text_bold" style="color: white">{{
                      $t("site_detail.collateral_short")
                    }}</span>
                </div>
                <div class="th trans_charter_active" v-if="charterShow" style="flex: 1">
                  <span class="cell_text_bold" style="color: white">{{
                      $t("interest.charter")
                    }}</span>
                </div>
                <div class="th trans_month_active" v-if="monthlyShow" style="flex: 1.8">
                  <span class="cell_text_bold" style="color: white">{{
                      $t("interest.monthly")
                    }}</span>
                </div>
                <div class="th trans_invest_active" v-if="investShow" style="flex: 1">
                  <span class="cell_text_bold" style="color: white">{{
                      $t("interest.invest")
                    }}</span>
                </div>
                <div class="th" style="flex: 1">
                  <span class="cell_text_bold">{{
                      $t("site_detail.private")
                    }}</span>
                </div>
                <div class="th" style="flex: 1" v-if="info.f_site_type == 'G'">
                  <span class="cell_text_bold">{{
                      $t("site_detail.real_size")
                    }}</span>
                </div>
                <div class="th" style="flex: 1">
                  <span class="cell_text_bold">{{
                      $t("site_detail.dup_teras")
                    }}</span>
                </div>
              </div>
              <div class="align-vertical tbody">
                <div
                  v-for="(room, index) in hoList
                    .sort((a, b) => {
                      if (a.f_floor != b.f_floor) {
                        return a.f_floor - b.f_floor;
                      } else {
                        return a.f_ho - b.f_ho;
                      }
                    })
                    .filter((it) => {
                      return it.f_complete == 'N';
                    })"
                  :key="`house-${index}`"
                >
                  <div
                    class="align-horizontal row_container"
                    v-if="room.f_memo == ''"
                  >
                    <div class="th blind" style="width: 50px">
                      <span class="cell_text">{{ renderText(room.f_ho) }}</span>
                    </div>
                    <div class="th blind" style="flex: 0.5">
                      <span class="cell_text">{{
                          renderText(room.f_room == 0 ? 1 : (room.f_room  == 1 ? 1.5 : room.f_room))
                        }}</span>
                    </div>
                    <div class="th blind" style="flex: 0.5">
                      <span class="cell_text">{{
                          renderText(room.f_toilet)
                        }}</span>
                    </div>
                    <div v-if="saleShow" class="th blind" style="flex: 1">
                      <span class="cell_text">{{
                          room.f_trans_type.split(',').includes('0') ? (
                            room.f_site_inquire_price == 'Y' ? $t('site_detail.site_inquire_short'):
                            renderText(u.currency(room.f_sale_price))) : '-'
                        }}</span>
                    </div>
                    <div v-if="saleShow" class="th blind" style="flex: 1">
                      <span class="cell_text">{{
                          room.f_trans_type.split(',').includes('0') ? (
                          room.f_site_inquire_price == 'Y' ? $t('site_detail.site_inquire_short'):
                            renderText(u.currency(room.f_collateral_price == null ? '' : room.f_collateral_price))) : '-'
                        }}</span>
                    </div>
                    <div v-if="charterShow" class="th blind" style="flex: 1">
                      <span class="cell_text">{{
                          room.f_trans_type.split(',').includes('1') ? (
                          room.f_site_inquire_charter == 'Y' ? $t('site_detail.site_inquire_short'):
                            renderText(u.currency(room.f_charter_price))) : '-'
                        }}</span>
                    </div>
                    <div v-if="monthlyShow" class="th blind" style="flex: 1.8">
                      <span class="cell_text">{{
                          room.f_trans_type.split(',').includes('3') ? (
                          room.f_site_inquire_month == 'Y' ? $t('site_detail.site_inquire_short'):
                            renderText(
                              [
                                u.currency(
                                  room.f_monthly_rent_deposit
                                    ? room.f_monthly_rent_deposit
                                    : ""
                                ),
                                u.currency(
                                  room.f_monthly_rent ? room.f_monthly_rent : ""
                                ),
                              ]
                                .filter((it) => {
                                  return it != "" && it != "0";
                                })
                                .join("/")
                            )) : '-'
                        }}</span>
                    </div>
                    <div v-if="investShow" class="th blind" style="flex: 1">
                      <span class="cell_text">{{
                          room.f_trans_type.split(',').includes('2') ? (
                          room.f_site_inquire_investment == 'Y' ? $t('site_detail.site_inquire_short'):
                            renderText(u.currency(room.f_investment_price))) : '-'
                        }}</span>
                    </div>
                    <div class="th blind" style="flex: 1">
                      <span class="cell_text">{{
                          renderText(room.f_exclusive_size)
                        }}</span>
                    </div>
                    <div class="th blind" style="flex: 1" v-if="false">
                      <span class="cell_text">{{
                          renderText(room.f_real_size)
                        }}</span>
                    </div>
                    <div class="th blind" style="flex: 1">
                      <span class="cell_text">{{
                          renderDupTerasText(room.f_duplex, room.f_teras)
                        }}</span>
                    </div>
                  </div>
                  <div class="align-horizontal" style="width: 100%" v-else>
                    <div
                      class="th_double"
                      style="
                        width: 50px;
                        display: flex;
                        border-left: solid 1px #d0d0d0;
                      "
                    >
                      <span class="item_label blind">{{
                          renderText(room.f_ho)
                        }}</span>
                    </div>
                    <div
                      class="th_double flex_1"
                      style="width: calc(100% - 50px)"
                    >
                      <div
                        class="align-horizontal th3 flex_1"
                        style="border-top-width: 0"
                      >
                        <div class="th2 blind" style="flex: 0.5;">
                          <span class="cell_text">{{
                              renderText(room.f_room == 0 ? 1 : (room.f_room  == 1 ? 1.5 : room.f_room))
                            }}</span>
                        </div>
                        <div class="th2 blind" style="flex: 0.5">
                          <span class="cell_text">{{
                              renderText(room.f_toilet)
                            }}</span>
                        </div>
                        <div v-if="saleShow" class="th2 blind" style="flex: 1">
                          <span class="cell_text">{{room.f_trans_type.split(',').includes('0') ? (room.f_site_inquire_price == 'Y' ? $t('site_detail.site_inquire_short'):
                            renderText(u.currency(room.f_sale_price))) : '-'
                            }}</span>
                        </div>
                        <div v-if="saleShow" class="th2 blind" style="flex: 1">
                          <span class="cell_text">{{room.f_trans_type.split(',').includes('0') ? (room.f_site_inquire_price == 'Y' ? $t('site_detail.site_inquire_short'):
                            renderText(u.currency(room.f_collateral_price == null ? '' : room.f_collateral_price))) : '-'
                            }}</span>
                        </div>
                        <div v-if="charterShow" class="th2 blind" style="flex: 1">
                          <span class="cell_text">{{room.f_trans_type.split(',').includes('1') ? (room.f_site_inquire_charter == 'Y' ? $t('site_detail.site_inquire_short'):
                            renderText(u.currency(room.f_charter_price))) : '-'
                            }}</span>
                        </div>
                        <div v-if="monthlyShow" class="th2 blind" style="flex: 1.8">
                          <span class="cell_text">{{room.f_trans_type.split(',').includes('3') ? (room.f_site_inquire_month == 'Y' ? $t('site_detail.site_inquire_short'):
                            renderText(
                              [
                                u.currency(
                                  room.f_monthly_rent_deposit
                                    ? room.f_monthly_rent_deposit
                                    : ""
                                ),
                                u.currency(
                                  room.f_monthly_rent ? room.f_monthly_rent : ""
                                ),
                              ]
                                .filter((it) => {
                                  return it != "" && it != "0";
                                })
                                .join("/")
                            )) : '-'
                            }}</span>
                        </div>
                        <div v-if="investShow" class="th2 blind" style="flex: 1">
                          <span class="cell_text">{{room.f_trans_type.split(',').includes('2') ? (room.f_site_inquire_investment == 'Y' ? $t('site_detail.site_inquire_short'):
                            renderText(u.currency(room.f_investment_price))) : '-'
                            }}</span>
                        </div>
                        <div class="th2 blind" style="flex: 1">
                          <span class="cell_text">{{
                              renderText(room.f_exclusive_size)
                            }}</span>
                        </div>
                        <div class="th2 blind" v-if="info.f_site_type == 'G'" style="flex: 1">
                          <span class="cell_text">{{
                              renderText(room.f_real_size)
                            }}</span>
                        </div>
                        <div class="th2 blind" style="flex: 1">
                          <span class="cell_text">{{
                              renderDupTerasText(room.f_duplex, room.f_teras)
                            }}</span>
                        </div>
                      </div>
                      <div class="flex_1">
                        <div
                          class="th flex_1"
                          style="display: flex; align-items: center"
                        >
                          <span
                            class="cell_text line-one"
                            style="text-align: left; padding-left: 10px"
                          >{{ replaceEnter(room.f_memo) }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--      renderHouseHold End-->

        <!--      renderGHousehold Start-->
        <div
          class="align-vertical block1"
          style="padding: 0 15px 15px 15px"
          v-if="info.f_site_type == 'G'"
        >
          <div
            class="v_center"
            style="margin-top: 0; background-color: #f4f5f6; height: 10px"
          />
          <div
            class="align-horizontal v_center"
            style="margin-top: 25px; align-items: center"
          >
            <span class="caption">{{ $t("site_detail.household_info") }}</span>
            <span class="update_time">
              {{
                ut.format(
                  $t("site_detail.update_date"),
                  info.f_update_time
                    ? info.f_update_time.substr(0, 10).replaceAll("-", "-")
                    : ""
                )
              }}
            </span>

            <div class="align-horizontal" style="flex: 1; justify-content: flex-end">
              <b-button
                v-if="self.myinfo.uid == info.f_user_idx || isAdmin || isGroupMember"
                class="btn btn_text dark_blue"
                variant="primary"
                @click="onModify()"
              >{{ $t("common.modify") }}</b-button>
            </div>
          </div>
          <div
            class="align-vertical table"
            style="margin-top: 5px; margin-bottom: 10px"
          >
            <div class="align-horizontal thead">
              <div
                class="th" :class="{'trans_trading_active': forRenderGHousehold.saleShow}"
                style="flex: 1"
              >
                <span class="cell_text_bold" style="color: white">{{ $t("interest.trading") }}</span>
              </div>
              <div
                class="th" :class="{'trans_trading_active': forRenderGHousehold.saleShow}"
                style="flex: 1"
              >
                <span class="cell_text_bold" style="color: white">{{ $t("site_detail.collateral") }}</span>
              </div>
              <div
                class="th" :class="{'trans_charter_active': forRenderGHousehold.charterShow}"
                style="flex: 1"
              >
                <span class="cell_text_bold" style="color: white">{{ $t("interest.charter") }}</span>
              </div>
              <div
                class="th" :class="{'trans_month_active': forRenderGHousehold.monthlyShow}"
                style="flex: 1"
              >
                <span class="cell_text_bold" style="color: white">{{ $t("interest.monthly") }}</span>
              </div>
              <div
                class="th" :class="{'trans_invest_active': forRenderGHousehold.investShow}"
                style="flex: 1"
              >
                <span class="cell_text_bold" style="color: white">{{ $t("interest.invest") }}</span>
              </div>
            </div>
            <div class="align-horizontal tbody">
              <div class="th_double" style="border-top-width: 0; flex: 2">
                <div class="align-horizontal th3 flex_1" style="border-top-width: 0; padding-top: 1px;">
                  <div class="th2 flex_1">
                    <span v-if="!forRenderGHousehold.saleShow" class="cell_text">{{renderText('')}}</span>
                    <span v-else class="cell_text">{{
                        info.f_site_inquire_price == "N"
                          ? renderText(u.currency(info.f_sale_price_min))
                          : info.f_site_inquire_price == "Y" ? $t('site_detail.site_inquire_short') : ""
                      }}</span>
                  </div>
                  <div class="th2 flex_1">
                    <span v-if="!forRenderGHousehold.saleShow" class="cell_text">{{renderText('')}}</span>
                    <span v-else class="cell_text">{{
                        info.f_site_inquire_price == "N"
                          ? renderText(u.currency(info.f_collateral_price == null ? '' : info.f_collateral_price))
                          : $t('site_detail.site_inquire_short')
                      }}</span>
                  </div>
                </div>
                <div class="align-horizontal th2 flex_1" style="padding: 0">
                  <div class="th3 flex_1 margin-left-10" style="padding-top: 3px; align-items: center; border-left-width: 0; margin: 0;">
                    <span v-if="!forRenderGHousehold.saleShow" class="cell_text">{{renderText('')}}</span>
                    <span v-else class="cell_text">{{
                        info.f_fee_site_inquire_price == 'Y' ? $t('site_detail.site_inquire_short') :
                          ($c.FEE_CHARTER_TYPE[parseInt(info.f_fee_trading_type)] + (!['0', null].includes(info.f_fee_trading) ? ('+' + renderText(u.currency(info.f_fee_trading))) : ''))
                      }}</span>
                  </div>
                </div>
              </div>
              <div class="th_double" style="flex: 3; border-top-width: 0">
                <div class="align-horizontal th3 flex_1" style="border-top-width: 0; padding-top: 1px;">
                  <div class="th2 blind flex_1">
                    <span class="cell_text" v-if="!forRenderGHousehold.charterShow">
                      {{replaceEnter('')}}
                    </span>
                    <sapn v-else class="cell_text">
                      {{info.f_site_inquire_charter == 'N' ? renderText(u.currency(info.f_charter_price_min)) : $t('site_detail.site_inquire_short')}}
                    </sapn>
                  </div>
                  <div class="th2 blind flex_1">
                    <span class="cell_text" v-if="!forRenderGHousehold.monthlyShow">
                      {{replaceEnter('')}}
                    </span>
                    <sapn v-else class="cell_text">
                      {{info.f_site_inquire_month == 'N' ? renderText([
                      u.currency(info.f_monthly_rent_min),
                      u.currency(info.f_monthly_rent_max)].filter(it => {
                      return it != '' && it != '0';
                    }).join('/')) : (info.f_site_inquire_month == 'Y' ? $t('site_detail.site_inquire_short'):'')}}
                    </sapn>
                  </div>
                  <div class="th2 blind flex_1">
                    <span class="cell_text" v-if="!forRenderGHousehold.investShow">
                      {{replaceEnter('')}}
                    </span>
                    <sapn v-else class="cell_text">
                      {{info.f_site_inquire_investment == 'N' ? renderText(u.currency(info.f_invest_price_min)) : $t('site_detail.site_inquire_short')}}
                    </sapn>
                  </div>
                </div>
                <div class="align-horizontal th3 flex_1" style="padding-top: 0">
                  <div class="th2 blind flex_1" style="border-top-width: 0">
                    <span v-if="forRenderGHousehold.charterShow" class="cell_text">
                      {{info.f_fee_site_inquire_charter == 'Y' ? $t('site_detail.site_inquire_short') : ($c.FEE_CHARTER_TYPE[parseInt(info.f_fee_charter_type)] + (!['0', null].includes(info.f_fee_charter) ? ('+' + info.f_fee_charter) : ''))}}
                    </span>
                  </div>
                  <div class="th2 blind flex_1" style="border-top-width: 0;">
                    <span v-if="forRenderGHousehold.monthlyShow" class="cell_text">
                      {{info.f_fee_site_inquire_month == 'Y' ? $t('site_detail.site_inquire_short') : info.f_fee_monthly_type == null  ? ($c.FEE_CHARTER_TYPE[parseInt(info.f_fee_monthly_type)] + (!['0', null].includes(info.f_fee_monthly) ? ('+' + info.f_fee_monthly) : '')) : ($c.FEE_CHARTER_TYPE[parseInt(info.f_fee_monthly_type)] + (!['0', null].includes(info.f_fee_monthly) ? ('+' + info.f_fee_monthly) : ''))}}
                    </span>
                  </div>
                  <div class="th2 blind flex_1" style="border-top-width: 0;">
                    <span v-if="forRenderGHousehold.investShow" class="cell_text">
                      {{info.f_fee_site_inquire_investment == 'Y' ? $t('site_detail.site_inquire_short') : ($c.FEE_CHARTER_TYPE[parseInt(info.f_fee_invest_type)] + (!['0', null].includes(info.f_fee_invest) ? ('+' + info.f_fee_invest) : ''))}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="align-horizontal thead">
              <div class="th" style="flex: 1">
                <span class="cell_text_bold">{{ $t("register.room") }}</span>
              </div>
              <div class="th" style="flex: 1">
                <span class="cell_text_bold">{{ $t("site_detail.toilet") }}</span>
              </div>
              <div class="th" style="flex: 1">
                <span class="cell_text_bold">{{ $t("site_detail.private1") }}</span>
              </div>
              <div class="th" style="flex: 1">
                <span class="cell_text_bold">{{ $t("site_detail.real_size1") }}</span>
              </div>
            </div>
            <div class="align-horizontal tbody">
              <div class="th1 flex_1">
                <span class="cell_text">{{renderText(forRenderGHousehold.roomNum)}}</span>
              </div>
              <div class="th1 flex_1">
                <span class="cell_text">{{renderText(info.f_toilet_num)}}</span>
              </div>
              <div class="th1 flex_1">
                <span class="cell_text">{{forRenderGHousehold.exclusiveAreaList.length > 0 ? renderText(forRenderGHousehold.exclusiveAreaList[0]) : '-'}}</span>
              </div>
              <div class="th1 flex_1">
                <span class="cell_text">{{forRenderGHousehold.realAreaList.length > 0 ? renderText(forRenderGHousehold.realAreaList[0]) : '-'}}</span>
              </div>
            </div>
            <div class="align-horizontal thead">
              <div class="th" style="flex: 1">
                <span class="cell_text_bold">{{ $t("site_detail.residence_type") }}</span>
              </div>
              <div class="th" style="flex: 1">
                <span class="cell_text_bold">{{ $t("map.elevator") }}</span>
              </div>
              <div class="th" style="flex: 1">
                <span class="cell_text_bold">{{ $t("site_detail.open_date") }}</span>
              </div>
              <div class="th" style="flex: 1">
                <span class="cell_text_bold">{{ $t("site_detail.dup_teras1") }}</span>
              </div>
            </div>
            <div class="align-horizontal tbody">
              <div class="th1 flex_1">
                <span class="cell_text">{{renderText2(info.f_residence_type)}}</span>
              </div>
              <div class="th1 flex_1">
                <span class="cell_text">{{renderText2(info.f_elevator)}}</span>
              </div>
              <div class="th1 flex_1">
                <span class="cell_text">{{renderText(info.f_open_date ? info.f_open_date.split('-')[0] : '')}}</span>
              </div>
              <div class="th1 flex_1">
                <span class="cell_text">{{renderDupTerasText(info.f_duplex, info.f_teras)}}</span>
              </div>
            </div>
          </div>
        </div>

        <!--      renderGHousehold End-->
        <!--      renderInlayInfo Start-->
        <div
          v-if="info.f_site_type === 'O'"
          class="align-vertical block1"
        >
          <div
            class="v_center"
            style="margin-top: 0; background-color: #f4f5f6; height: 10px; padding-left: 15px; padding-right: 15px;"
          />

          <div class="align-horizontal v_center" style="margin-top: 10px;margin-bottom: 5px; padding-right: 15px;">
            <div class="align-horizontal flex_1" style="align-items: center">
              <span class="caption">{{
                  $t("site_detail.inlay_picture") +
                  forRenderInlayInfo.inlay_title_prefix
                }}</span>
              <span class="update_time">{{
                  ut.format(
                    $t("site_detail.update_date"),
                    info.f_update_inlay_time
                      ? info.f_update_inlay_time
                        .substr(0, 10)
                        .replaceAll("-", "-")
                      : ""
                  )
                }}</span>
            </div>

          </div>
          <div>
            <span class="caption" style="float: right;font-size: 17px; padding-left: 15px; padding-right: 15px;" v-if="info.f_fee_type">{{
                renderFeeType(info)
              }}</span>
          </div>

          <div
            class="align-vertical"
            v-if="forRenderInlayInfo.imageUrls.length > 0 && canShowInlayInfo()"
            style="
              position: relative;
              margin-top: 10px;
              width: 100%;
              margin: auto;
            "
          >
            <CCarousel
              v-model="activeInlayIndex"
              :interval="0"
              cStyle="text-shadow: 1px 1px 2px #333; z-index: 0"
            >
              <b-carousel-slide
                v-for="img in forRenderInlayInfo.imageUrls"
                :img-src="img"
              >
                <template slot="img">
                  <div class="slide-content" style="height: 480px">
                    <b-img
                      style="max-width: 100%; height: 100%; object-fit: contain;"
                      @click="onGallery('I')"
                      :src="img"
                    />
                  </div>
                </template>
              </b-carousel-slide>
            </CCarousel>
          </div>
        </div>
        <!--      renderInlayInfo End-->

        <!--      renderMemo Start-->
        <div
          class="align-vertical block1"
          style="padding-bottom: 7px"
          :class="{ 'pt-2': !info.f_inlay_image_url }"
        >
          <div class="align-horizontal space_between" >
            <span class="caption">{{
                info.f_site_type == "U"
                  ? $t("site_report.want_say_manager")
                  : $t("site_detail.memo")
              }}</span>
            <div
              class="align-horizontal v_center"
              v-if="info.f_site_type != 'U'"
            >
              <span
                class="btn_txt1"
                style="color: #cf0000; margin-right: 10px; font-size: 18px"
              >
                {{
                  u.isEmpty(recent_notify_info)
                    ? $t("site_detail.no_recent_notification")
                    : recent_notify_info.f_recent_noti_ago_date == 0
                      ? $t("site_detail.recent_notification_today")
                      : ut.format(
                        $t("site_detail.recent_notification_days"),
                        recent_notify_info.f_recent_noti_ago_date
                      )
                }}
              </span>
              <b-button
                class="btn1 download"
                variant="primary"
                @click="
                  () => {
                    u.requestGet(self.$c.API.Notify.getNotifyDetail, {
                      notify_idx: this.recent_notify_info.f_idx,
                    }).then((result) => {
                      if (result.code == self.$c.API_RES_CODE.SUCCESS) {
                        u.setState(self, { notify: result.data.info }, () => {
                          self.showDetailNotifyPopup = true;
                        });
                      } else u.toast(result.msg);
                    });
                  }
                "
              >
                <span class="btn_txt1">{{
                    $t("site_detail.view_notify")
                  }}</span>
              </b-button>
            </div>
          </div>
          <div
            class="textarea_wrap"
            style="margin: 12px 0 20px;"
          >
            <pre class="textarea">{{ info.f_memo }}</pre>
          </div>
          <div
            class="v_center"
            style="margin-top: 0; background-color: #f4f5f6; height: 10px"
          />
          <div
            class="align-horizontal v_center space_between"
            v-if="forRenderMemo.imageUrls.length > 0"
            style="margin: 16px 0 4px; align-items: baseline"
          >
            <span class="caption">{{ $t("site_detail.represent_photo") }}</span>
            <b-button
              class="btn1 download btn_txt1"
              variant="primary"
              @click="onDownloadImage(forRenderMemo.imageUrls)"
            >
              {{ $t("common.download") }}
            </b-button>
          </div>
          <div
            class="align-vertical"
            v-if="forRenderMemo.imageUrls.length > 0"
            style="
              position: relative;
              margin-top: 10px;
              width: 100%;
              margin: auto;
            "
          >
            <CCarousel
              v-model="activeIndex"
              :interval="0"
              controls
              cStyle="text-shadow: 1px 1px 2px #333; z-index: 0"
            >
              <b-carousel-slide
                v-for="img in forRenderMemo.imageUrls"
                :img-src="img"
              >
                <template slot="img">
                  <div class="slide-content" style="height: 480px">
                    <b-img
                      style="max-width: 100%; height: 100%; object-fit: contain;"
                      @click="onGallery('P')"
                      :src="img"
                    />
                  </div>
                </template>
              </b-carousel-slide>
            </CCarousel>
          </div>
        </div>
        <!--      renderMemo End-->

        <!--      renderLocation Start-->
        <div class="align-vertical block" style="padding-bottom: 15px;">
          <div style="margin-top: 15px; align-items: baseline">
            <span class="caption">{{ $t("site_detail.location_info") }}</span>
          </div>
          <iframe
            ref="webref"
            id="webref"
            @load="onLoadEnd"
            class="map no_border"
            src="https://app.madepf.com/web_map3.html"
          ></iframe>
          <div class="align-horizontal">
            <b-button
              class="more_btn more_btn_text flex_1"
              variant="white"
              style="background-color: white"
              @click="onShowUtilityBuilding"
            >
              {{ $t("site_detail.more_locations") }}
            </b-button>
          </div>
        </div>
        <!--      renderLocation End-->
        <div style="margin-top: -20px; background-color: white; height: 10px" />
      </div>
      <Gallery
        :visible.sync="galleryPopupShow"
        :src="
          (which == 'I' ? forRenderInlayInfo.imageUrls :
          (which == 'M' ? memoImages : forRenderMemo.imageUrls))
        "
        :current="(which == 'I' ? activeInlayIndex :
          (which == 'M' ? 0 : activeIndex))"
      />
      <NotifyDetailPopup
        v-if="showDetailNotifyPopup"
        :visible.sync="showDetailNotifyPopup"
        :item="notify"
      />
      <FacilitiesPopup :visible.sync="showFacilitiesPopup" :site="info" />
      <RoomInfoPopup
        :visible.sync="showPopup"
        :site="info"
        :room="roomInfo"
        @onDownload="(imageUrl, type) => onDownloadImage(imageUrl, type)"
      />
      <SiteReportPopup :visible.sync="showSiteReportPopup" :item="info" />
      <SetSaleCompletePopup
        :visible.sync="showSetSaleCompletePopup"
        :site_idx="siteIdx"
        @onCancel="
        u.setState(self, {
          showSetSaleCompletePopup: false,
        })
      "
      />
      <SiteInquiry v-if="inquiryKeyword != null" :visible.sync="showSiteInquiryPopup" :keyword="inquiryKeyword" :page="page"/>
    </div>
  </b-modal>
</template>

<script>
import MdHeaderBar from "../../../controls/MdHeaderBar";
import Utils from "../../../../config/utils";
import Axios from "axios";
import RoomInfoPopup from "../../../controls/popup/RoomInfoPopup";
import Gallery from "../../../controls/Gallery";
import CarouselIndicator from "../../../controls/CarouselIndicator";
import FacilitiesPopup from "../../../controls/popup/FacilitiesPopup";
import CCarousel from "../../../controls/CCarousel";
import NotifyDetailPopup from "../../../controls/popup/NotifyDetailPopup1";
import SiteReportPopup from "../../../controls/popup/SiteReportPopup";
import SetSaleCompletePopup from "../../../controls/popup/SetSaleCompletePopup";
import SiteInquiry from "./SiteInquiry.vue";

const INTRO_TIME = 500;
const util = require("util");
export default {
  name: "SiteDetail",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    site: {
      type: Object,
      default: () => {},
    },
    detailPopupAlign: {
      type: String,
      default: 'center'
    },
    page: {
      type: String,
      default: ''
    }
  },
  inject: ["eventBus"],
  components: {
    NotifyDetailPopup,
    FacilitiesPopup,
    CarouselIndicator,
    RoomInfoPopup,
    MdHeaderBar,
    Gallery,
    CCarousel,
    SiteReportPopup,
    SetSaleCompletePopup,
    SiteInquiry
  },
  data() {
    return {
      self: this,
      u: Utils,
      ut: util,
      siteIdx: this.site.common.f_idx,
      info: this.site.common,
      memo: this.site.memo,
      memoImages:  this.site.memo_images
        ? this.site.memo_images.split(",").filter((it) => {
          return it != "";
        })
        : [],
      contactList: this.site.contact_list,
      dongList: this.site.dong_list,
      hoList: this.site.ho_list,
      // hoList: this.site.ho_list.map((it) => {
      //   it.f_room = it.f_room == 0 ? 1 : it.f_room == 1 ? 1.5 : it.f_room;
      //   return it;
      // }),
      roomList: this.site.room_list,
      lat: this.site.common.f_latitude,
      lon: this.site.common.f_longitude,
      recent_notify_info: this.site.recent_notify_info,
      activeIndex: 0,
      activeInlayIndex: 0,
      showPopup: false,
      showFacilitiesPopup: false,
      roomInfo: {},
      notify: {},
      showExtendPopup: false,
      showDetailNotifyPopup: false,
      galleryPopupShow: false,
      showSiteReportPopup: false,
      showSetSaleCompletePopup: false,
      which: "I",
      isAdmin: this.myinfo.isAdmin(),
      isGroupMember: this.site.isGroupMember,
      showSiteInquiryPopup:false,
      inquiryKeyword:null,
    };
  },
  methods: {
    onSearch() {
      this.inquiryKeyword = this.u.getAddress(this.info, true);
      this.showSiteInquiryPopup = true;
    },
    renderRoomNum(text) {
      let rlt;
      text = parseInt(text)
      if (text == 0)
        rlt = 1
      else if(text == 1)
        rlt = 1.5;
      else
        rlt = text;
      return rlt;
    },
    onLoadEnd() {
      //TODO:
      this.$refs.webref.contentWindow.postMessage(
        {
          type: "1",
          lat: this.lat,
          lon: this.lon,
          state: this.info.f_site_type,
          title: this.info.f_name,
        },
        "*"
      );
    },
    onSiteReport(report_type) {
      // this.setState({showSiteReportPopup: false}, ()=>{
      let msg = this.$t("site_report.report_inaccurate_disadvantage");
      if (report_type == "SC") {
        msg = this.$t("site_report.report_inaccurate_disadvantage1");
      }
      Utils.showConfirm(
        this,
        "[" +
        Utils.getReportTypeText(report_type) +
        "] " +
        this.$t("site_report.ask_report") +
        "<br/>" +
        "<span style='color:#cf0000;font-size: 22px;line-height: 60px;'>" +
        msg +
        "</span>"
      ).then((val) => {
        if (val) {
          Utils.requestPost(this.$c.API.Site.reportSite, {
            site_idx: this.siteIdx,
            report_type: report_type,
            complete_status: "Y", // TODO: 정확한 분양완료상태
          }).then((result) => {
            if (result.code == this.$c.API_RES_CODE.SUCCESS) {
              Utils.toast(
                this,
                `[${Utils.getReportTypeText(report_type)}] ${this.$t(
                  "interest.report_confirm_click"
                )}`
              );
              // this.props.onCompleteReport();
            } else {
              Utils.toast.show(this, result.msg);
            }
          });
        }
      });
    },
    onSiteCompletePopup() {
      this.showSetSaleCompletePopup = true;
    },
    onCompleteReport() {
      this.showSiteReportPopup = true;
    },
    onModify() {
      // TODO: go to update sale page
      Utils.requestGet(this.$c.API.Site.getSiteDetail, {
        site_idx: this.siteIdx,
      }).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          let data = result.data;
          Utils.requestGet(this.$c.API.Site.getSiteDetail, {
            site_idx: data.common.f_idx,
          }).then((result) => {
            if (result.code == this.$c.API_RES_CODE.SUCCESS) {
              if (result.data.common.f_site_type === "G") {
                this.$router.push({
                  name: "RegSite1",
                  params: {
                    type: "General",
                    common: result.data.common,
                    contact_list: result.data.contact_list,
                    room_list: result.data.room_list,
                  },
                });
              } else if (result.data.common.f_site_type === "O") {
                this.$router.push({
                  name: "RegSite1",
                  params: {
                    type: "New",
                    isReadOnly: false,
                    common: result.data.common,
                    ho_list: result.data.ho_list,
                    dong_list: result.data.dong_list,
                    contact_list: result.data.contact_list,
                    room_list: result.data.room_list,
                  },
                });
              }
            }
          });
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },
    onCancel() {
      if (window.history.state == "forward") window.history.back();
    },

    onShowSiteDetail() {
      console.log("-------------onshowdetail----------------");
      this.eventBus.$emit("setModal", this);
      window.history.pushState("forward", null);
      Utils.setState(this, {
        siteIdx: this.site.common.f_idx,
        info: this.site.common,
        memo: this.site.memo,
        contactList: this.site.contact_list,
        dongList: this.site.dong_list,
        hoList: this.site.ho_list,
        roomList: this.site.room_list,
        lat: this.site.common.f_latitude,
        lon: this.site.common.f_longitude,
        recent_notify_info: this.site.recent_notify_info,
        isGroupMember: this.site.isGroupMember,
        showSiteInquiryPopup: false,
        inquiryKeyword:null,
      });
      this.eventBus.$on('sale_complete', this.updateSiteInfo)
    },
    updateSiteInfo() {
      Utils.requestGet(
        this.$c.API.Site.getSiteDetail,
        {
          site_idx: this.siteIdx,
        },
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.siteInfo =  result.data;
          Utils.setState(this, {
            info: this.siteInfo.common,
            memo: this.siteInfo.memo,
            contactList: this.siteInfo.contact_list,
            dongList: this.siteInfo.dong_list,
            hoList: this.siteInfo.ho_list.map(it => {
              it.f_room = it.f_room == 0 ? 1 : (it.f_room == 1 ? 1.5 : it.f_room);
              return it;
            }),
            roomList: this.siteInfo.room_list,
            lat: this.siteInfo.common.f_latitude,
            lon: this.siteInfo.common.f_longitude,
            recent_notify_info: this.siteInfo.recent_notify_info,
            isGroupMember: this.siteInfo.isGroupMember,
          });
        } else {
          Utils.toast(this, result.msg);
        }

      });
    },
    onGallery(which) {
      this.galleryPopupShow = true;
      this.which = which;
    },
    canShowInlayInfo() {
      return this.info.f_inlay_private == "N";
    },
    renderFeeType(item) {
      console.log(item);
      let result = [];
      let feeTypes = item.f_fee_type.split(",").filter((it) => {
        return it != "";
      });

      let maemulTypes = []
      if (item.f_site_type == 'O')
      {
        this.hoList.forEach((ho) => {
          ho.f_trans_type.split(',')
            .filter(it => {
              return it != '';
            }).forEach(it => {
            if (maemulTypes.indexOf(Number(it)) < 0)
              maemulTypes.push(Number(it))
          })
        })
      }

      let f_monthly_rent_min = 0;
      let f_monthly_rent_max = 0;
      if (!this.hoMode && this.hoList.length >= 1 && item.f_site_type == 'O') {
        let sale_price_list = this.hoList.filter(it => {return it.f_complete == 'N' && it.f_site_inquire_price != 'Y' && it.f_trans_type.split(',').includes(String(this.$c.MAEMUL_TYPE.TRADING))}).map(it => Number(it.f_sale_price))
        let collateral_price_list = this.hoList.filter(it => {return it.f_complete == 'N'  && it.f_site_inquire_price != 'Y' && it.f_trans_type.split(',').includes(String(this.$c.MAEMUL_TYPE.TRADING))}).map(it => Number(it.f_collateral_price))
        let charter_price_list = this.hoList.filter(it => {return it.f_complete == 'N' && it.f_site_inquire_charter != 'Y' && it.f_trans_type.split(',').includes(String(this.$c.MAEMUL_TYPE.CHARTER))}).map(it => Number(it.f_charter_price))
        let invest_price_list = this.hoList.filter(it => {return it.f_complete == 'N' && it.f_site_inquire_investment != 'Y' && it.f_trans_type.split(',').includes(String(this.$c.MAEMUL_TYPE.INVEST))}).map(it => Number(it.f_investment_price))
        let month_rent_price_list = this.hoList.filter(it => {return it.f_complete == 'N' && it.f_site_inquire_month != 'Y' && it.f_trans_type.split(',').includes(String(this.$c.MAEMUL_TYPE.MONTHLY))}).map(it => Number(it.f_monthly_rent))

        item.f_sale_price_min = Math.min(...sale_price_list)
        item.f_sale_price_max = Math.max(...sale_price_list)
        item.f_charter_price_min = Math.min(...charter_price_list)
        item.f_charter_price_max = Math.max(...charter_price_list)
        item.f_invest_price_min = Math.min(...invest_price_list)
        item.f_invest_price_max = Math.max(...invest_price_list)
        f_monthly_rent_min = Math.min(...month_rent_price_list) // 월세
        f_monthly_rent_max = Math.max(...month_rent_price_list) // 월세

        item.f_collateral_price = Math.max(...collateral_price_list) // 담보금
        item.f_site_inquire_price = this.hoList.filter(it => {return it.f_complete == 'N'})
          .some(it => it.f_trans_type.split(',').includes('0') && it.f_site_inquire_price == 'Y') ? 'Y' : 'N'
        item.f_site_inquire_charter = this.hoList.filter(it => {return it.f_complete == 'N'})
          .some(it => it.f_trans_type.split(',').includes('1') && it.f_site_inquire_charter == 'Y') ? 'Y' : 'N'
        item.f_site_inquire_investment = this.hoList.filter(it => {return it.f_complete == 'N'})
           .some(it => it.f_trans_type.split(',').includes('2') && it.f_site_inquire_investment == 'Y') ? 'Y' : 'N'
        item.f_site_inquire_month = this.hoList.filter(it => {return it.f_complete == 'N'})
           .some(it => it.f_trans_type.split(',').includes('3') && it.f_site_inquire_month == 'Y') ? 'Y' : 'N'
      } else if (this.hoMode && item.f_site_type == 'O') {
        this.f_monthly_rent_min = item.f_monthly_rent_min // 월세보증금
        this.f_monthly_rent_max = item.f_monthly_rent_max // 월세
      }
      if (item.f_site_type != 'O') {
        f_monthly_rent_min = item.f_monthly_rent_min // 월세보증금
        f_monthly_rent_max = item.f_monthly_rent_max // 월세
      }

      let showTrading = false;
      if (item.f_sale_price_min == Infinity && item.f_sale_price_max == -Infinity && item.f_site_inquire_price == 'N') {
        showTrading = false;
      } else {
        showTrading = true;
      }
      console.log("show, Trading=", showTrading);
      if (maemulTypes.indexOf(this.$c.MAEMUL_TYPE.TRADING) > -1 && showTrading) {
        let tmp = this.$t('register.r_residence') + ' ';
        if (item.f_fee_trading == '0' || item.f_fee_trading == null || feeTypes.indexOf(this.$c.FEE_TYPES.TRADING) < 0)
          tmp += this.$t('site_detail.site_inquire');
        else
          tmp += item.f_fee_trading
        result.push(tmp)
      }

      let showCharter = false;
      if (item.f_charter_price_min == Infinity && item.f_charter_price_max == -Infinity && item.f_site_inquire_charter == 'N') {
        showCharter = false;
      } else {
        showCharter = true;
      }
      console.log("show, Charter=", showCharter);
      if (maemulTypes.indexOf(this.$c.MAEMUL_TYPE.CHARTER) > -1 && showCharter) {
        let tmp = this.$t('interest.charter') + ' ';
        if (feeTypes.indexOf(this.$c.FEE_TYPES.CHARTER) < 0)
          tmp += this.$t('site_detail.site_inquire')
        else {
          tmp +=  this.$c.FEE_CHARTER_TYPE[parseInt(item.f_fee_charter_type)];
          if (parseFloat(item.f_fee_charter) > 0) {
            tmp += '+' + item.f_fee_charter;
          }
        }
        result.push(tmp);
      }

      let showMonth = false;
      if (f_monthly_rent_min == Infinity && f_monthly_rent_max ==  -Infinity && item.f_site_inquire_month == 'N') {
        showMonth = false;
      } else {
        showMonth = true;
      }
      console.log("show, Month = " + showMonth);
      if (maemulTypes.indexOf(this.$c.MAEMUL_TYPE.MONTHLY) > -1 && showMonth) {
        let tmp = this.$t("interest.monthly") + ' ';
        if (feeTypes.indexOf(this.$c.FEE_TYPES.MONTHLY) < 0)
          tmp += this.$t('site_detail.site_inquire')
        else {
          tmp +=  this.$c.FEE_CHARTER_TYPE[parseInt(item.f_fee_monthly_type)];
          if (parseFloat(item.f_fee_monthly) > 0) {
            tmp += '+' + item.f_fee_monthly;
          }
        }
        result.push(tmp);
      }

      let showInvestment = false;
      if (item.f_invest_price_min == Infinity && item.f_invest_price_max ==  -Infinity && item.f_site_inquire_investment == 'N') {
        showInvestment = false;
      } else {
        showInvestment = true;
      }
      console.log("show, Investment = " + showInvestment);
      if (maemulTypes.indexOf(this.$c.MAEMUL_TYPE.INVEST) > -1 && showInvestment) {
        let tmp = this.$t('interest.invest') + ' ';
        if (item.f_fee_invest == '0' || item.f_fee_invest == null || feeTypes.indexOf(this.$c.FEE_TYPES.INVESTMENT) < 0)
          tmp += this.$t("site_detail.site_inquire")
        else {
          tmp += item.f_fee_invest
        }
        result.push(tmp)
      }
      // if (feeTypes.includes('S')) {
      //   result.push(Langs.map.site_check);
      // }
      // if (feeTypes.includes('O')) {
      //   result.push(Langs.map.court);
      // }
      return result.join(' / ');
    },
    renderFeeTypeG(item) {
      let itemCnt = 0;
      let result = [];
      let feeTypes = item.f_fee_type.split(",").filter((it) => {
        return it != "";
      });
      if (feeTypes.includes("T")) {
        itemCnt = itemCnt + 1;
        result.push(
          util.format(this.$t("site_detail.r_single_hit"), item.f_fee_trading)
        );
      }
      if (feeTypes.includes("C")) {
        let tmp = "";
        if (itemCnt < feeTypes.length && itemCnt > 0) {
          tmp = "\n";
        }
        itemCnt = itemCnt + 1;

        tmp += this.$c.FEE_CHARTER_TYPE[parseInt(item.f_fee_charter_type)];
        if (parseFloat(item.f_fee_charter) > 0) {
          tmp += " +" + item.f_fee_charter;
        }
        result.push(tmp);
      }
      if (feeTypes.includes("I")) {
        let tmp = "";
        if (itemCnt < feeTypes.length) {
          tmp = "\n";
        }
        itemCnt = itemCnt + 1;

        result.push(tmp + this.$t("interest.invest") + " " + item.f_fee_invest);
      }
      if (feeTypes.includes("S")) {
        let tmp = "";
        if (itemCnt < feeTypes.length) {
          tmp = "\n";
        }
        itemCnt = itemCnt + 1;

        result.push(tmp + this.$t("map.site_check"));
      }
      if (feeTypes.includes("O")) {
        let tmp = "";
        if (itemCnt < feeTypes.length) {
          tmp = "\n";
        }
        itemCnt = itemCnt + 1;

        result.push(tmp + this.$t("map.court"));
      }

      result = result.join(" ");
      if (itemCnt == 1) {
        return result.replace("\n", "");
      } else {
        return result.replace(" / ", "\n");
      }
    },
    renderText(text) {
      return text == null || text == '0' || text == '0000' ? '-' : text;
    },
    renderText1(text) {
      if (text == null || text == '' || text == '0')
        return '-';
      if (text == 1 || text == '1' || text == 'Y')
        return 'O'
      return 'X'
    },

    renderText2 (text){
      if (text == null || text == '' || text == '0' || text == 'U')
        return '-';
      if (text == 1 || text == '1' || text == 'Y')
        return 'O'
      return 'X'
    },
    replaceEnter(text) {
      return text.replace(/\n/g, " ");
    },
    renderDupTerasText(isDup, isTeras) {
      let resultText = "-";
      if (isDup == 'Y' && isTeras == 'Y') {
        resultText = this.info.f_site_type == 'O' ? this.$t('site_detail.dup_teras') : this.$t('site_detail.dup_teras1');
      } else if (isDup == 'Y') {
        resultText = this.info.f_site_type == 'O' ?  this.$t('room_info_popup.duplex_short') :  this.$t('room_info_popup.duplex');
      } else if (isTeras == 'Y') {
        resultText = this.info.f_site_type == 'O' ?  this.$t('site_detail.teras_short') :  this.$t('site_detail.teras');
      }

      return resultText;
    },
    getTransText(defaultText, room, info) {
      let roomTransTypeList = room.f_trans_type.split(",").filter((it) => {
        return it != "" && it != "3";
      });
      let infoTransTypeList = info.f_transaction_type
        .split(",")
        .filter((it) => {
          return it != "" && it != "3";
        });

      if (
        roomTransTypeList.length == 2 &&
        (room.f_trans_type.includes("0,2") || room.f_trans_type.includes("2,0"))
      ) {
        return this.$t("interest.trading1");
      }

      return roomTransTypeList.length > 1 && infoTransTypeList.length > 1
        ? this.$t("dongsi")
        : defaultText;
    },
    getInfo() {
      Utils.requestGet(this.$c.API.Site.getSiteDetail, {
        site_idx: this.siteIdx,
      }).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          Utils.setState(this, {
            info: result.data.common,
            contactList: result.data.contact_list,
            dongList: result.data.dong_list,
            hoList: result.data.ho_list,
            roomList: result.data.room_list,
            memo: result.data.memo,
          });
          Utils.setState(this, {
            lat: result.data.common.f_latitude,
            lon: result.data.common.f_longitude,
          });

          this.$refs.webref.contentWindow.postMessage(
            {
              type: "1",
              lat: this.lat,
              lon: this.lon,
              state: this.info.f_site_type,
              title: this.info.f_name,
            },
            "*"
          );
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    buildLink() {
      // const idx = this.siteIdx;
      // const link = dynamicLinks().buildShortLink({
      //   link: `http://madepf.com?site_idx=${idx}`,
      //   domainUriPrefix: 'https://madepf.page.link',
      //   android: {
      //       packageName: 'co.kr.made',
      //   },
      //   ios: {
      //       bundleId: 'co.kr.made',
      //       appStoreId: '2573880050',
      //   }
      // });
      //
      // return link;
    },

    onShare() {
      //TODO: 공유하기단추를 눌렀을때의 기능실현
      let link_url = window.location.origin + "/ShareSite/" + this.info.f_idx;
      function handler(event) {
        event.clipboardData.setData("text/plain", link_url);
        event.preventDefault();
        document.removeEventListener("copy", handler, true);
      }
      document.addEventListener("copy", handler, true);
      document.execCommand("copy");
      Utils.toast(this, link_url);
    },

    onLike() {
      let likeStatus = this.info.f_like == "Y" ? "N" : "Y";
      Utils.requestPost(this.$c.API.Site.setLikeSite, {
        site_idx: this.siteIdx,
        like_status: likeStatus,
      }).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          Utils.setState(this, {
            info: Object.assign({}, this.info, {
              f_like: likeStatus,
            }),
          });
          this.eventBus.$emit("site_detail_like", this.siteIdx);
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    onSaveMyMemo() {
      Utils.requestPost(this.$c.API.Site.addSiteMemo, {
        site_idx: this.siteIdx,
        memo: this.memo,
        memo_images: this.memoImages.length > 0 ? this.memoImages.join(',') : '',
      }).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          Utils.toast(this, this.$t("common.save_success"));
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    onShowMyMemoImage() {
      if (this.memoImages.length < 1) {
        Utils.toast(this, '첨부된 이미지가 없습니다.');
        return;
      }
      this.onGallery('M');
    },

    onAttachMyMemoImage() {
      this.$refs["img-file"].click();
    },

    onRemoveMyMemoImage() {
      if (this.memoImages.length < 1) {
        Utils.toast(this, '삭제할 이미지가 없습니다.');
        return;
      }
      Utils.showConfirm(this, '마지막 이미지가 삭제됩니다.').then(
        value => {
          if(value){
            this.memoImages.pop();
            Utils.toast(this, '삭제되었습니다.');
          }
        }
      )
    },

    onImageChange(){
      let file = this.$refs['img-file'].files[0];
      Utils.requestUpload(
        this,
        this.$c.API.Upload.image,
        file,
        '2'
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          this.memoImages.push(result.data.url);
          Utils.toast(this, '첨부되었습니다.\n저장 버튼을 눌러주세요.');
        } else {
          // Utils.toast(this,result.msg);
          Utils.toast(this, '첨부되지 않았습니다. 다시 시도해주세요.');
        }
      });
    },

    onShowUtilityBuilding() {
      Utils.setState(this, {
        showFacilitiesPopup: true,
      });
    },

    onPhone(number, name) {
      //TODO: 전화하기 기능 실현
      Utils.callPhone(this, number, name);
    },

    onNavi() {
      // TODO: navi app실행
      Utils.onNavi(
        this,
        this.info.f_longitude,
        this.info.f_latitude,
        this.info.f_address1,
        this.info.f_address1
      );
    },
    copyAddress() {
      // TODO: 주소 복사
      Utils.copyAddress(
        this,
        this.info.f_longitude,
        this.info.f_latitude,
        this.info.f_address1
      );
    },
    onDownloadImage(imageUrls, type = null) {
      let path_prefix, destPath;
      if (this.info.f_address2 === "" || this.info.f_address2 === null) {
        path_prefix = `${this.info.f_address1}_${this.info.f_name}`;
      } else {
        path_prefix = `${this.info.f_address2}_${this.info.f_name}`;
      }

      let _site_arr = path_prefix.split(" ");
      if (_site_arr.length > 2) {
        path_prefix =
          _site_arr[_site_arr.length - 2] + _site_arr[_site_arr.length - 1];
      }
      let siteName = this.info.f_name;

      let idx = 0;
      imageUrls.forEach((url) => {
        let _arr = url.split("/");
        let fileName = _arr[_arr.length - 1];
        if (type !== null) {
          destPath = `${path_prefix}_${type}`;
        } else {
          destPath = `${path_prefix}`;
        }
        destPath = destPath.replace("Made_", "");
        destPath = destPath.replace(" ", "");

        // if (!this.$store.getters.isLoading)
        //   this.$store.commit("setLoading", true);
        // this.$store.commit(
        //   "setLoadingText",
        //   util.format(this.$t("downloaded_files_desc"), idx, imageUrls.length)
        // );

        url = url.replace("http://app.madepf.com", "https://app.madepf.com");

        // Utils.downloadItem(url, `${destPath}/${fileName}`);
        Axios.get(url, {
          responseType: "blob",
          onDownloadProgress: (progressEvent) => {
            let percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            console.log(progressEvent.lengthComputable);
            console.log(percentCompleted);
          },
        })
          .then((response) => {
            const blob = new Blob([response.data], {
              type: response.data.type,
            });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = `${destPath}/${fileName}`;
            link.click();
            URL.revokeObjectURL(link.href);
            idx++;
            this.$store.commit(
              "setLoadingText",
              util.format(
                this.$t("downloaded_files_desc"),
                idx,
                imageUrls.length
              )
            );
            console.log(`Total Downloaded: ${(idx / imageUrls.length) * 100}%`);
            if (idx == imageUrls.length) {
              let msg = destPath + " 에 저장되었습니다.";
              Utils.toast(this, msg);
              this.$store.commit("setLoading", false);
              this.$store.commit("setLoadingText", "");
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      });
    },
    onMessage(e) {
      try {
        let data = JSON.parse(e.data);
        if (data.type == "1") {
          this.onCancel();
        }
      } catch (e) {

      }
    },
  },

  beforeDestroy() {
    window.removeEventListener("message", this.onMessage);
  },
  mounted() {
    window.addEventListener("message", this.onMessage, false);
  },
  computed: {
    startTime() {
      return new Date().getTime();
    },

    maemul_type() {
      let maemul_type = this.info.f_maemul_type
        ? this.info.f_maemul_type
          .split(",")
          .filter((it) => {
            return !Utils.isEmptyOrNull(it);
          })
          .map((it) => {
            return this.$c.MAEMUL_TYPE_MAP['' + it];
          })
        : [];
      return maemul_type;
    },
    parking_info() {
      let parking_info = this.info.f_parking_type
        ? this.info.f_parking_type
          .split(",")
          .filter((it) => {
            return !Utils.isEmptyOrNull(it);
          })
          .map((it) => {
            return this.$t("parking_info")[it];
          })
        : [];
      return parking_info;
    },
    forRenderHousehold() {
      const { info, dongList, hoList } = this;

      let list = [];
      dongList.forEach((dong) => {
        let floorList = {};
        hoList
          .filter((ho) => {
            return ho.f_dong_idx == dong.f_idx;
          })
          .forEach((it) => {
            if (!floorList.hasOwnProperty(it.f_floor)) {
              floorList[it.f_floor] = [];
            }
            floorList[it.f_floor].push(it);
          });

        let ho_list = hoList.filter((ho) => {
          return ho.f_dong_idx == dong.f_idx;
        });
        let saleShow = ho_list.some((it) => {
          return it.f_trans_type.split(",").includes("0") && it.f_complete != 'Y';
        });
        // saleShow = saleShow && info.f_transaction_type.includes("0");

        let charterShow = ho_list.some((it) => {
          return it.f_trans_type.split(",").includes("1") && it.f_complete != 'Y';
        });
        // charterShow = charterShow && info.f_transaction_type.includes("1");

        let investShow = ho_list.some((it) => {
          return it.f_trans_type.split(",").includes("2") && it.f_complete != 'Y';
        });
        // investShow = investShow && info.f_transaction_type.includes("2");

        let monthlyShow = ho_list.some((it) => {
          return it.f_trans_type.split(",").includes("3") && it.f_complete != 'Y';
        });
        // monthlyShow = monthlyShow && info.f_transaction_type.includes("3");

        list.push({
          dong_id: dong.f_idx,
          dong_name: dong.f_dong,
          hoList: ho_list,
          floorList: floorList,
          saleShow: saleShow,
          charterShow: charterShow,
          investShow: investShow,
          monthlyShow: monthlyShow,
        });
      });
      return list;
    },
    forRenderGHousehold() {
      const { info, roomList } = this;

      let saleShow = info.f_transaction_type.includes("0") && info.f_complete != 'Y';
      let charterShow = info.f_transaction_type.includes("1") && info.f_complete != 'Y';
      let investShow = info.f_transaction_type.includes("2") && info.f_complete != 'Y';
      let monthlyShow = info.f_transaction_type.includes("3") && info.f_complete != 'Y';

      let roomNum =
        info.f_room_num == 0 ? 1 : info.f_room_num == 1 ? 1.5 : info.f_room_num;
      // blas 20230620
      // if (roomNum == "4") {
      //   roomNum += "▲";
      // }
      // if (info.f_duplex == "Y") {
      //   roomNum += `(${this.$t("site_detail.dup")})`;
      // }
      info.f_toilet_num = info.f_toilet_num
        .split(",")
        .filter((it) => {
          return it != "";
        })
        .sort((a, b) => {
          return b - a;
        })[0];
      // blas 20230620
      // if (info.f_toilet_num == "3") {
      //   info.f_toilet_num += "▲";
      // }

      let exclusiveAreaList = roomList
        .filter((it) => {
          return it.f_area == "E";
        })
        .map((it) => {
          return it.f_exclusive_pyong;
        })
        .sort((a, b) => {
          return b - a;
        });

      let realAreaList = roomList
        .filter((it) => {
          return it.f_area == "R";
        })
        .map((it) => {
          return it.f_real_pyong;
        })
        .sort((a, b) => {
          return b - a;
        });
      return {
        saleShow: saleShow,
        charterShow: charterShow,
        investShow: investShow,
        monthlyShow: monthlyShow,
        exclusiveAreaList: exclusiveAreaList,
        realAreaList: realAreaList,
        roomNum: roomNum,
      };
    },
    forRenderInlayInfo() {
      const { info } = this;
      let imageUrls = info.f_inlay_image_url
        ? info.f_inlay_image_url.split(",").filter((it) => {
          return it != "";
        })
        : [];
      let inlay_title_prefix = "";
      if (imageUrls.length == 0)
        inlay_title_prefix = `(${this.$t("map.none")})`;
      else {
        if (!this.canShowInlayInfo())
          inlay_title_prefix = `(${this.$t("register.private")})`;
      }
      return {
        imageUrls: imageUrls,
        inlay_title_prefix: inlay_title_prefix,
      };
    },
    forRenderMemo() {
      const { info } = this;
      let imageUrls = info.f_image_urls
        ? info.f_image_urls.split(",").filter((it) => {
          return it != "";
        })
        : [];
      return {
        imageUrls: imageUrls,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/css/main/interest/SiteDetail";
@import "../../../../assets/css/vars";
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.caption1 {
  color: black;
  font-size: $fs_18;
  font-family: $korean_gd_15_r;
}
.btn_txt1 {
  color: white;
  font-size: $fs_14;
  font-family: $korean_gd_14_r;
  text-align: center;
}

.btn_memo {
  width: 40px;
  height: 30px;
}

.download {
  //border-radius: 5px;
  height: 32px;
  background-color: $c_457fff;
  width: 70px;
}
.dark_blue {
  background-color: #0840ba!important;
}
.del_btn_color {
  background-color: #999999!important;
}
.inquiry_btn1 {
  position: fixed; bottom: 90px; right: calc(100% - 480px); z-index: 100;
}
.inquiry_btn2 {
  position: fixed; bottom: 10px; right: calc(50% - 240px); z-index: 100;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/interest/SiteDetail.vue